var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1061",
    "data-name": "Rectangle 1061",
    width: 15.567,
    height: 15.567,
    fill: "#0d0d0d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5712",
    "data-name": "Group 5712",
    transform: "translate(-138.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_43",
    "data-name": "Ellipse 43",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(138.126)",
    fill: "#e84c4c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5709",
    "data-name": "Group 5709",
    transform: "translate(157.843 20.217)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3718",
    "data-name": "Path 3718",
    d: "M10.067,7.784l5.027-5.027A1.615,1.615,0,0,0,12.811.473L7.784,5.5,2.757.473A1.615,1.615,0,1,0,.473,2.757L5.5,7.784.473,12.811a1.615,1.615,0,0,0,2.284,2.284l5.027-5.027,5.027,5.027a1.615,1.615,0,0,0,2.284-2.284Z",
    transform: "translate(0 0)",
    fill: "#0d0d0d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentRejected);
export default __webpack_public_path__ + "static/media/payment-rejected.cc4ff814e013ed8664980a288e257336.svg";
export { ForwardRef as ReactComponent };